import React from "react";

import { PositionedLabel } from "@/react/features/styled/PositionedLabel";
import DateTimeSelector from "@8x8/oxygen-date-time-selector";
import DateTimeRangeSelector from "@8x8/oxygen-date-time-range-selector";
import { parseOxygenDateRange } from "@/react/datetime";

const LabeledDateSelector = ({
  value,
  setValue,
  defaultValue = null,
  prompt,
  placeholder,
  singleDate = false,
  format,
  onDateTimeChanged,
  htmlId,
  ...other
}) => {
  React.useEffect(
    () => setValue && setValue(value ?? defaultValue),
    [value, defaultValue]
  );

  const handleDateChanged = (dateTime) => {
    setValue && setValue(dateTime);
    onDateTimeChanged && onDateTimeChanged(dateTime);
  };

  const handleDateRangeChanged = (dateTimeRange) => {
    const parsedRange = dateTimeRange.dateTime
      ? parseOxygenDateRange(dateTimeRange)
      : defaultValue;
    setValue && setValue(parsedRange);
    onDateTimeChanged && onDateTimeChanged(dateTime);
  };

  return (
    <div>
      {prompt && <PositionedLabel>{prompt}</PositionedLabel>}
      {singleDate ? (
        <DateTimeSelector
          value={value}
          placeholder={placeholder}
          onDateChange={handleDateChanged}
          titleFormatPattern={format}
          closeOnDateChange
          testId={htmlId}
          id={htmlId}
          {...other}
        />
      ) : (
        <DateTimeRangeSelector
          dateTimeRange={value}
          placeholder={placeholder}
          dateFormat={format}
          hideTime
          hidePredefinedRanges
          onRangeChange={handleDateRangeChanged}
          testId={htmlId}
          id={htmlId}
          {...other}
        />
      )}
    </div>
  );
};

export default LabeledDateSelector;
